import React, { useEffect, useState } from 'react';
import { func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import _ from 'lodash';

import { Checkbox, FormControl, MenuItem, FormControlLabel, FormGroup, InputLabel, Radio, Select } from '@material-ui/core';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ContactActions from '../../../actions/contactActions';
import * as HomeActions from '../../../actions/homeActions';

import classes from './CreateSubscriptionModal.module.css';

const CreateSubscriptionModal = ({
    areas,
    contacts,
    createSubscription,
    fetchAreas,
    fetchCampusAndSiteNodes,
    fetchClientContacts,
    clientContacts,
    currentUserId,
    fetchContacts,
    handleToggleSubscribeToAlertsModal,
    parent,
    parentLabel,
    type,
    ...props
}) => {

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            if (type === 'campus') {
                let campuses = await fetchCampusAndSiteNodes(parent.clientId);
                campuses = campuses.filter(item => item.type === 'campus');
                setCampusList(campuses);
            }
            
            if (type === 'area') {
                await fetchAreas(parent.siteId);
            }

            if (process.env.contactsEnabled) {
                await fetchClientContacts(parent.clientId);
            } else {
                await fetchContacts(parent.clientId);
            }
            setIsLoading(false);
        };

        if (parent.clientId) init();
    }, [parent]);

    const [subscriptionMethod, setSubscriptionMethod] = useState({
        email: false,
        sms:   false
    });
    const [isLoading, setIsLoading] = useState(false);
    const [contact, setContact] = useState('none');
    const [campusList, setCampusList] = useState([]);
    const [campus, setCampus] = useState();
    const [area, setArea] = useState();

    const [subscribe, setSubscribe] = useState('self');

    const handleSubscribe = (event) => {
        setSubscribe(event.target.value);
    };

    const handleSubscriptionChange = (event) => {
        setSubscriptionMethod({ ...subscriptionMethod, [event.target.name]: event.target.checked });
    };

    const handleContactChange = (event) => {
        const contact = event.target.value;
        setContact(contact);
    };

    const handleCampusChange = event => {
        const campus = event.target.value;
        setCampus(campus);
    };

    const handleAreaChange = event => {
        const area = event.target.value;
        setArea(area);
    };

    const isDisabled = () => {
        if (isLoading || !Object.values(subscriptionMethod).includes(true) || (subscribe !== 'self' && contact === 'none') || (type === 'campus' && !campus) || (type === 'area' && !area)) {
            return true;
        }
        return false;
    };

    const handleCreate = async () => {
        let isCreated;

        const selfSubscription = {
            subscriberid:   currentUserId,
            subscribertype: 'user'
        };

        const clientContactSubscription = {
            subscriberid:   contact.userId,
            subscribertype: 'contact'
        };

        let body = {
            email:       subscriptionMethod.email,
            entityid:    type === 'campus' ? campus.id : type === 'area' ? area.id : parent.id,
            entityName:  type === 'campus' ? campus.name : type === 'area' ? area.name : parent.name,
            sms:         subscriptionMethod.sms,
            userid:      currentUserId,
            subscribers: []
        };

        if (type === 'rule') {
            body.ruleId = parent.ruleId;
        }

        switch (subscribe) {
            case 'self':
                body.subscribers = [selfSubscription];
                break;
            case 'clientContact':
                body.subscribers = [clientContactSubscription];
                break;
            case 'both':
                body.subscribers = [selfSubscription, clientContactSubscription];
                break;
            default:
                break;
        }

        if (!isLoading) {
            setIsLoading(true);
            isCreated = await createSubscription(body);
        }

        setIsLoading(false);
        if (isCreated) handleToggleSubscribeToAlertsModal(false);
    };

    return (
        <BobModal
            title={'Subscribing to Alerts'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => handleToggleSubscribeToAlertsModal(false)}
        >
            <div className={classes.Body}>
                <div className={classes.SubHeader}>
                    <div className={classes.Icon}><i className="fas fa-info-circle" /></div>
                    <div>Subscribing allows you to review alerts for this and any child entity</div>
                </div>
                <div className={classes.EntityContainer}>
                    {
                        type === 'campus' ?
                            <FormControl variant="outlined" size="small" className={classes.SelectContainer}>
                                <InputLabel htmlFor="outlined-contact-native-simple">Campus</InputLabel>
                                <Select
                                    value={campus}
                                    onChange={handleCampusChange}
                                    label="Campus"
                                    inputProps={{
                                        name: 'contact',
                                        id:   'outlined-contact-native-simple',
                                    }}
                                >
                                    <MenuItem value="none" disabled>
                                        Select Campus
                                    </MenuItem>
                                    {
                                        campusList.map((campus, index) =>
                                            <MenuItem
                                                key={index}
                                                value={campus}
                                            >
                                                {campus.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                            :
                            type === 'area' ?
                                <FormControl variant="outlined" size="small" className={classes.SelectContainer}>
                                    <InputLabel htmlFor="outlined-contact-native-simple">Area</InputLabel>
                                    <Select
                                        value={area}
                                        onChange={handleAreaChange}
                                        label="Area"
                                        inputProps={{
                                            name: 'area',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Area
                                        </MenuItem>
                                        {
                                            areas.map((area, index) =>
                                                <MenuItem
                                                    key={index}
                                                    value={area}
                                                >
                                                    {area.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                                :
                                type === 'rule' ?
                                    <div>
                                        <div>
                                            <InputLabel
                                                className={classes.EntityLabel}
                                                htmlFor="Label"
                                            >
                                                {parentLabel}
                                            </InputLabel>
                                            <div>
                                                {parent.name}
                                            </div>
                                        </div>
                                        <div style={{paddingTop: '1rem'} }>
                                            <InputLabel
                                                className={classes.EntityLabel}
                                                htmlFor="rule"
                                            >
                                                Rule Name
                                            </InputLabel>
                                            <div>
                                                {parent.ruleName}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <React.Fragment>
                                        <InputLabel
                                            className={classes.EntityLabel}
                                            htmlFor="Label"
                                        >
                                            {parentLabel}
                                        </InputLabel>
                                        <div>
                                            {parent.name}
                                        </div>
                                    </React.Fragment>
                    }

                </div>
                <div>
                    <span className={classes.SubText}>Subscription Method</span>
                    <FormGroup className={classes.FormGrouping}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={subscriptionMethod.email}
                                    onChange={handleSubscriptionChange}
                                    name="email"
                                    style={{
                                        color: 'black'
                                    }}
                                />
                            }
                            label={<span style={{ fontSize: '1.4rem' }}>Email</span>}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={subscriptionMethod.sms}
                                    onChange={handleSubscriptionChange}
                                    name="sms"
                                    style={{
                                        color: 'black'
                                    }}
                                />
                            }
                            label={<span style={{ fontSize: '1.4rem' }}>SMS</span>}
                        />
                    </FormGroup>
                    { parent.clientId ?
                        <React.Fragment>
                            <span className={classes.SubText}>Subscribe</span>
                            <FormGroup className={classes.FormGrouping}>
                                <FormControlLabel
                                    onChange={handleSubscribe}
                                    value="self"
                                    disabled={!parent.clientId}
                                    control={
                                        <Radio
                                            checked={subscribe === 'self'}
                                            style={{
                                                color: 'black'
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: '1.4rem' }}>Self</span>}
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    onChange={handleSubscribe}
                                    value="clientContact"
                                    disabled={!parent.clientId}
                                    control={
                                        <Radio
                                            checked={subscribe === 'clientContact'}
                                            style={{
                                                color: 'black'
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: '1.4rem' }}>Client Contact</span>}
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    onChange={handleSubscribe}
                                    value="both"
                                    disabled={!parent.clientId}
                                    control={
                                        <Radio
                                            checked={subscribe === 'both'}
                                            style={{
                                                color: 'black'
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: '1.4rem' }}>Both</span>}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                            <FormControl variant="outlined" size="small" className={classes.SelectContainer}>
                                <InputLabel htmlFor="outlined-contact-native-simple">Contact</InputLabel>
                                <Select
                                    disabled={subscribe === 'self' || !parent.clientId}
                                    value={contact}
                                    onChange={handleContactChange}
                                    label="Contact"
                                    inputProps={{
                                        name: 'contact',
                                        id:   'outlined-contact-native-simple',
                                    }}
                                >
                                    <MenuItem value="none" disabled>
                                        Select Contact
                                    </MenuItem>
                                    {
                                        process.env.contactsEnabled ?
                                            clientContacts.map(contact =>
                                                <MenuItem
                                                    key={contact.id}
                                                    value={contact}
                                                >
                                                    {`${contact.userName.FirstName} ${contact.userName.LastName}`}
                                                </MenuItem>
                                            )
                                            :
                                            contacts.map(contact =>
                                                <MenuItem
                                                    key={contact.id}
                                                    value={contact.id}
                                                >
                                                    {contact.name}
                                                </MenuItem>
                                            )
                                    }
                                </Select>
                            </FormControl>
                        </React.Fragment>
                        : null}
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobCancelButton
                    disabled={isLoading}
                    onClick={() => handleToggleSubscribeToAlertsModal(false)}
                    className={classes.CancelButton}
                    label={'Close'}
                />
                <BobConfirmButton
                    disabled={isDisabled()}
                    onClick={() => handleCreate()}
                    className={isDisabled() ? classes.DisabledButtons : classes.Buttons}
                    label={'Ok'}
                    iconSize={15}
                    isLoading={isLoading}
                />
            </div>
        </BobModal>
    );
};

CreateSubscriptionModal.propTypes = {
    createSubscription:                 func.isRequired,
    currentUserId:                      string.isRequired,
    fetchContacts:                      func.isRequired,
    handleToggleSubscribeToAlertsModal: func.isRequired,
    parent:                             object.isRequired,
    parentLabel:                        string.isRequired
};

const mapStateToProps = state => {
    const {
        contacts,
        order,
        orderBy: orderByKey
    } = state.architect;

    return {
        areas:          state.architect.areas,
        clientContacts: state.contact.clientContacts,
        contacts:       _.orderBy(contacts, [orderByKey], order),
        currentUserId:  state.currentUser.id,
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ContactActions,
    ...HomeActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateSubscriptionModal);
